const state = {
  httpLoading: false
}

const mutations = {
  SETLOADING (state, value) {
    state.httpLoading = value
  }
}

const actions = {
  setHttpLoading ({ commit }, value) {
    commit('SETLOADING', value)
  }
}

export default { state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/store.js